/**
 * @version GENERATOR_VERSION::20200504
 * @DateTime 2020-07-08T19:32:01.8
 * @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
 **/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'rentmanage-rentleasecontractchangerequest-'

export default {
    path: '/rentmanage/rentleasecontractchangerequest',
    name: 'rentmanage-rentleasecontractchangerequest',
    redirect: {
        name: '${pre}-index'
    },

    meta: {
        ...meta,
    },

    component: BasicLayout,
    children: [{
            path: 'index',
            name: '${pre}rentleasecontractchangerequest-index',

            meta: {
                ...meta,
                title: '退租管理'
            },

            component: () => import('@/pages/rentmanage/rentleasecontractchangerequest/index'),
        },
        {
            path: 'detail-edit/:id',
            name: '${pre}rentleasecontractchangerequest-detail-edit',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '租约退换续转管理编辑'
            },

            component: () => import('@/pages/rentmanage/rentleasecontractchangerequest/detail-edit'),
        },
        {
            path: 'detail-edit',
            name: '${pre}rentleasecontractchangerequestdetail-create',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '租约退换续转管理新增'
            },

            component: () => import('@/pages/rentmanage/rentleasecontractchangerequest/detail-edit'),
        },
        {
            path: 'detail-view/:id',
            name: '${pre}rentleasecontractchangerequestView',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '租约退换续转管理详情查看'
            },

            component: () => import('@/pages/rentmanage/rentleasecontractchangerequest/detail-view'),
        },
    ]
};
